import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import { mediaMin, mediaMax } from './sizes';

const COLUMNS = 12;

const StyledGrid = styled.div`
  display: block;
  width: 100%;
  padding: 0 16px;
  flex: 0 0 auto;
  margin-left: ${props => props.push && (100 / COLUMNS) * props.push + '%'};
  margin-right: ${props => props.pull && (100 / COLUMNS) * props.pull + '%'};
  ${mediaMin.phone`
     width: ${props => props.sm && (100 / COLUMNS) * props.sm + '%'};
     margin-left: ${props =>
       props.pushSm && (100 / COLUMNS) * props.pushSm + '%'};
     margin-right: ${props =>
       props.pullSm && (100 / COLUMNS) * props.pullSm + '%'};
  `} 
  ${mediaMin.tablet`
     width: ${props => props.md && (100 / COLUMNS) * props.md + '%'};
     margin-left: ${props =>
       props.pushMd && (100 / COLUMNS) * props.pushMd + '%'};
     margin-right: ${props =>
       props.pullMd && (100 / COLUMNS) * props.pullMd + '%'};
  `} 
  ${mediaMin.container`
     width: ${props => props.lg && (100 / COLUMNS) * props.lg + '%'};
     margin-left: ${props =>
       props.pushLg && (100 / COLUMNS) * props.pushLg + '%'};
     margin-right: ${props =>
       props.pullLg && (100 / COLUMNS) * props.pullLg + '%'};
  `} 
`;

export const GridRow = styled.div`
  display: flex;
  margin: 0 -16px;
  ${mediaMax.phone`
     display: block;
  `}
`;

const Grid = ({
  sm,
  md,
  lg,
  pushSm,
  pullSm,
  pushMd,
  pullMd,
  pushLg,
  pullLg,
  children,
  className,
}) => {
  return (
    <StyledGrid
      className={className}
      sm={sm}
      md={md}
      lg={lg}
      pushSm={pushSm}
      pullSm={pullSm}
      pushMd={pushMd}
      pullMd={pullMd}
      pushLg={pushLg}
      pullLg={pullLg}
    >
      {children}
    </StyledGrid>
  );
};

Grid.propTypes = {
  sm: PropTypes.number,
  md: PropTypes.number,
  lg: PropTypes.number,
  pushSm: PropTypes.number,
  pushMd: PropTypes.number,
  pushLg: PropTypes.number,
  pullSm: PropTypes.number,
  pullMd: PropTypes.number,
  pullLg: PropTypes.number,
};

export default Grid;
